import { configureStore } from '@reduxjs/toolkit';
import { userApi } from './api/user.api';
import { subscriptionsApi } from './api/subscription.api';
import { itemApi } from './api/item.api';
import { deviceApi } from './api/device.api';
import { basketApi } from './api/basket.api';
import { wishlistApi } from './api/wishlist.api';
import {orderApi} from './api/order.api';
import { addingOrderApi } from './api/addingOrder.api';
import { promoApi } from './api/promo.api.js';
import { topupApi } from './api/topup.api';
import { settingsApi } from './api/settings.api';

import userReducer from './slices/user.slice.js';

export const store = configureStore({
  reducer: {
    [userApi.reducerPath]: userApi.reducer,
    [subscriptionsApi.reducerPath]: subscriptionsApi.reducer,
		[itemApi.reducerPath]: itemApi.reducer,
    [deviceApi.reducerPath]: deviceApi.reducer,
    [basketApi.reducerPath]: basketApi.reducer,
    [wishlistApi.reducerPath]: wishlistApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [addingOrderApi.reducerPath]: addingOrderApi.reducer,
    [promoApi.reducerPath]: promoApi.reducer,
    [topupApi.reducerPath]: topupApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    user: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(userApi.middleware)
      .concat(subscriptionsApi.middleware)
			.concat(itemApi.middleware)
      .concat(deviceApi.middleware)
      .concat(basketApi.middleware)
      .concat(wishlistApi.middleware)
      .concat(orderApi.middleware)
      .concat(addingOrderApi.middleware)
      .concat(promoApi.middleware)
      .concat(topupApi.middleware)
      .concat(settingsApi.middleware)
});
